/** parsePlaylistFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parsePlaylistFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  astrosite_id: params.get("astrosite_id"),
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "from", // The column to sort by
})
